import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface FootingsFoundationConcreteProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const FootingsFoundationConcrete: React.FC<FootingsFoundationConcreteProps> = ({
    required = false,
    propertyGuid,
    isReview = false,
}) => {
    const [footingsFoundationConcrete, set_footingsFoundationConcrete] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Foundations']?.['Footings, Foundation and Concrete'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Foundations': { ...b.values?.['Foundations'], 'Footings, Foundation and Concrete': v } } })
    );
    const label = 'Footings, Foundation and Concrete';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(footingsFoundationConcrete)}
                />
            ) : (
                <MoneyBox
                    id={'footingsFoundationConcrete'}
                    allowNegative={false}
                    value={footingsFoundationConcrete}
                    onChange={(value) => set_footingsFoundationConcrete(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
